<template>
  <view class="c-count-down-content">
    {{ prefix}}
    <template v-if="day > 0"><text :style="textStyle">{{ day }}</text>{{ computeColon.day }}</template>
    <template v-if="hour > 0 || day > 0"><text :style="textStyle">{{ hour }}</text>{{ computeColon.hour }}</template>
    <text :style="textStyle">{{ minute }}</text>{{ computeColon.minute }}
    <text :style="textStyle">{{ second }}</text>{{ computeColon.second }}
    {{ suffix }}
  </view>
</template>

<script setup lang="ts">
import type { CSSProperties } from '@vue/runtime-dom';
import { computed, toRefs } from 'vue';

interface Props {
  day: number | string;
  hour: number | string;
  minute: number | string;
  second: number | string;
  suffix?: string;
  prefix?: string;
  showColon?: boolean;
  textStyle?: CSSProperties;
}
const props = withDefaults(defineProps<Props>(), {
  showColon: true,
});
const { day, hour, minute, second, showColon, suffix, prefix, textStyle } = toRefs(props);

const computeColon = computed(() => {
  let config = {
    day: `天`,
    hour: `时`,
    minute: `分`,
    second: `秒`,
  };

  if (showColon.value) {
    config.hour = `:`;
    config.minute = `:`;
    config.second = ``;
  }

  return config;
});
</script>

<style scoped lang="scss">
.c-count-down-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
